module.exports = __webpack_public_path__ + "static/img/button1.2a83084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/bodyfriend/button1.png
// module id = FxXH
// module chunks = 1